import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const GridClassName = `${CLASS_NAME_PREFIX}-flex`;
